import { ForwardedRef, forwardRef } from 'react';

import { SvgIcon } from './SvgIcon.styled';
import { Props } from './types';
import { icons } from './icons';

// eslint-disable-next-line @typescript-eslint/no-unused-vars
const Icon = ({ icon, fontSize, size = 16, sx, ...props }: Props, ref: ForwardedRef<any>) => {
  const iconValue = icons[icon];
  const {
    icon: [width, height, , , svgPathData],
  } = iconValue;

  return (
    <SvgIcon
      classes={{ root: icon }}
      fontSize="inherit"
      ref={ref}
      sx={{ fontSize: size, ...sx }}
      viewBox={`0 0 ${width} ${height}`}
      {...props}
    >
      {iconValue['nxtCustom'] ? (
        iconValue.iconDom
      ) : typeof svgPathData === 'string' ? (
        <path d={svgPathData} />
      ) : (
        svgPathData.map((d: string) => <path d={d} key={d} />)
      )}
    </SvgIcon>
  );
};

export default forwardRef(Icon);
